export const CLIENT_LIB_VERSION = '1.34.0'
